import { useMutation, useQueryClient } from '@tanstack/react-query'

import { messageApi } from '../api/messageApi'
import { getConversationsPreviewOptions } from './useConversationsPreviewQuery'
import { getConversationOptions } from './useSingleConversationQuery'

export const useBlockConversationMutation = (conversationId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => messageApi.blockConversation(conversationId),
    onSuccess: () => {
      queryClient.setQueryData(
        getConversationOptions(conversationId).queryKey,
        (data) =>
          data && {
            ...data,
            isBlocked: true,
          },
      )
      queryClient.setQueryData(
        getConversationsPreviewOptions().queryKey,
        (data) =>
          data && {
            ...data,
            pages: data.pages.map((page) =>
              page.map((conversation) =>
                conversation.id === conversationId ? { ...conversation, isBlocked: true } : conversation,
              ),
            ),
          },
      )
    },
  })
}
